







































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import { storePasien } from "@/store/modules/pasien";
import CpptRanapPage from "@/components/soap/CpptRanapPage.vue";
import AsesmenRanapMedisPage from "./AsesmenRanapMedisPage.vue";
import AsesmenRanapKeperawatanPage from "@/components/pemeriksaan/tabs/rekam-medis/asesmen-ranap-keperawatan/AsesmenRanapKeperawatanPage.vue";
import ResumeRanap from "@/pages/ResumeRanap.vue";
import TandaVitalEws from "@/components/TandaVitalEws.vue";
import CardPemeriksaanFisik from "@/components/pemeriksaan/assesmen/pemeriksaanfisik/CardPemeriksaanFisik.vue";
import CardAsesmenRisikoJatuh from "@/components/pemeriksaan/assesmen/CardAsesmenRisikoJatuh.vue";
import AnamnesisPage from "@/pages/pemeriksaan_ranap/AnamnesisPage.vue";
import CatatanPemberianObatPage from "@/pages/pemeriksaan_ranap/CatatanPemberianObatPage.vue";
import AsesmenNyeriPage from "@/components/pemeriksaan/assesmen/AsesmenNyeriPage.vue";
import AsesmenRisikoJatuhPage from "@/components/pemeriksaan/assesmen/AsesmenRisikoJatuhPage.vue";
import SkriningGiziLanjutPage from "@/components/pemeriksaan/tabs/rekam-medis/SkriningGiziLanjutPage.vue";
import PemantauanTerapiGiziPage from "@/components/pemeriksaan/tabs/rekam-medis/PemantauanTerapiGiziPage.vue";
import SkriningPaliatifDewasaPage from "@/components/pemeriksaan/tabs/rekam-medis/SkriningPaliatifDewasaPage.vue";
import SkriningPaliatifAnakPage from "@/components/pemeriksaan/tabs/rekam-medis/SkriningPaliatifAnakPage.vue";
import SkriningBunuhDiriPage from "@/components/pemeriksaan/tabs/rekam-medis/SkriningBunuhDiriPage.vue";
import LaporanOperasiPage from "./pemeriksaan_ranap/LaporanOperasiPage.vue";
import CardAsesmenPraSedasi from "@/components/pemeriksaan/assesmen/CardAsesmenPraSedasi.vue";
import CardAsesmenPraBedah from "@/components/pemeriksaan/tabs/rekam-medis/asesmen-pra-bedah/CardAsesmenPraBedah.vue";
import AskepRanapPage from "@/components/pemeriksaan/AskepRanapPage.vue";
import RefAskepRanapPage from "@/components/pemeriksaan/RefAskepRanapPage.vue";
import storeReferensiUnit from "@/store/modules/new/ReferensiUnit";
import TransferInternalPage from "@/components/pti/TransferInternalPage.vue";
import MppPage from "@/pages/pemeriksaan_ranap/MppPage.vue";
import MppModule from "@/store/modules/MppStore";
import ptiStore from "@/store/modules/pti";
import RekonsiliasiObatPage from "./pemeriksaan_ranap/RekonsiliasiObatPage.vue";
import CatatanPemberianObatStore from "@/store/modules/CatatanPemberianObat";
import KriteriaHcuPage from "@/pages/pemeriksaan_ranap/KriteriaHcuPage.vue";
import PemantauanPacuPage from "@/pages/pemeriksaan_ranap/PemantauanPacuPage.vue";
import CardPengkajianRestrain from "@/components/pemeriksaan/tabs/rekam-medis/CardPengkajianRestrain.vue";
import IdentitasBayiBaruLahirPage from "@/pages/IdentitasBayiBaruLahirPage.vue";
import EwssAnakPage from "@/components/pemeriksaan/assesmen/EwssAnakPage.vue";
import GrafikTtvDewasaPage from "@/components/pemeriksaan/assesmen/GrafikTtvDewasaPage.vue";
import CardCeklistProsedurInvasif from "@/components/pemeriksaan/assesmen/CardCeklistProsedurInvasif.vue";
import ChecklistPersiapanAnestesiPage from "./pemeriksaan_ranap/ChecklistPersiapanAnestesiPage.vue";
import ChecklistKeselamatanOperasiPage from "@/components/pemeriksaan/assesmen/perioperatif/ChecklistKeselamatanOperasiPage.vue";
import CatatanPraSedasiPage from "@/components/pemeriksaan/assesmen/anestesi/CatatanPraSedasiPage.vue";
import CardCatatanPaskaSedasi from "@/components/pemeriksaan/assesmen/CardCatatanPaskaSedasi.vue";
import CatatanKebidananPage from "@/components/pemeriksaan/assesmen/kebidanan/CatatanKebidananPage.vue";
import Partograf from "@/components/pemeriksaan/Partograf.vue";
import AsesmenAwalKebidananPage from "@/components/pemeriksaan/assesmen/AsesmenAwalKebidananPage.vue";
import AsesmenAwalAnakPage from "@/components/pemeriksaan/assesmen/AsesmenAwalAnakPage.vue";
import CardAsesmenBayiBaruLahir from "@/components/pemeriksaan/assesmen/CardAsesmenBayiBaruLahir.vue";
import CardCatatanEdukasi from "@/components/pemeriksaan/assesmen/catatanedukasi/CardCatatanEdukasi.vue";
import CardAsesmenPerinatal from "@/components/pemeriksaan/assesmen/CardAsesmenPerinatal.vue";
import CatatanHarianBblPage from "@/components/pemeriksaan/catatan-harian-bbl/CatatanHarianBblPage.vue";
import MonitoringHarianNicuPage from "@/components/pemeriksaan/monitoring-harian-nicu/MonitoringHarianNicuPage.vue";
import AsesmenPopulasiKhususPage from "@/components/pemeriksaan/assesmen/AsesmenPopulasiKhususPage.vue";
import AsesmenGeriatriPage from "@/components/pemeriksaan/assesmen/AsesmenGeriatriPage.vue";
import { isUsiaGeriatri } from "@/utils/usiaPasien";
import PengkajianAkhirHayatPage from "@/components/pemeriksaan/tabs/rekam-medis/pengkajianakhirhayat/PengkajianAkhirHayatPage.vue";
import CodeBlueActivationPage from "@/components/pemeriksaan/tabs/rekam-medis/codeBlue/CodeBlueActivationPage.vue";
import IcuHcuPage from "@/components/pemeriksaan/icu-hcu/IcuHcuPage.vue";
import BundlePpiPage from "@/components/pemeriksaan/bundle-ppi/BundlePpiPage.vue";
import PenggunaanAlatReuseRanapTab from "@/components/pemeriksaan/alat-reuse/PenggunaanAlatReuseRanapTab.vue";
import KepatuhanVisiteRanapTab from "@/components/kepatuhan-visite-dpjp/KepatuhanVisiteRanapTab.vue";
import AsesmenKeperawatanIntensifPage from "@/pages/pemeriksaan_ranap/AsesmenKeperawatanIntensifPage.vue";
import LembarObservasiKebidananPage from "@/components/pemeriksaan/tabs/rekam-medis/lembar-observasi-kebidanan/LembarObservasiKebidananPage.vue";
import ObservasiKebidananBishopPage from "@/components/pemeriksaan/tabs/rekam-medis/observasi-kebidanan-bishop/ObservasiKebidananBishopPage.vue";
import CpBlankoPage from "@/components/pemeriksaan/tabs/rekam-medis/clinical-pathway/CpBlankoPage.vue";
import CardSebabKematian from "@/components/pemeriksaan/tabs/ringkasan-masuk-keluar/CardSebabKematian.vue";
import AskeperPerioperatifPage from "@/pages/pemeriksaan_ranap/AskeperPerioperatifPage.vue";
import PemantauanAnestesiList from "@/components/PemantauanAnestesi/PemantauanAnestesiList.vue";
import MonitoringIntraOpLokalPage from "@/pages/MonitoringIntraOpLokalPage.vue";
import MonitoringTransfusiList from "@/components/MonitoringTransfusi/MonitoringTransfusiList.vue";
import MonitoringGdsList from "@/components/MonitoringGds/MonitoringGdsList.vue";
import CardNihssAssessment from "@/components/pemeriksaan/tabs/rekam-medis/CardNihssAssessment.vue";
import CardAssesmenKemoterapi from "@/components/pemeriksaan/tabs/rekam-medis/CardAssesmenKemoterapi.vue";
import TabBerkasRm from "@/components/pemeriksaan/berkasRm/TabBerkasRm.vue";
import CardDischargePlanning from "@/components/pemeriksaan/tabs/persetujuan/CardDischargePlanning.vue";
import RekamAsuhanHemodialisisPage from "@/components/pemeriksaan/tabs/rekam-medis/rekam-asuhan-hemodialisis/RekamAsuhanHemodialisisPage.vue";
import MonitoringTrombolisisList from "@/components/pemeriksaan/tabs/rekam-medis/MonitoringTrombolisis/MonitoringTrombolisisList.vue";

// Canonical form grouping (category + order) lives in the search registry so the
// vertical tabs and the universal form search on PasienFlyingBar share one source
// of truth. See docs/ref-desk-review/...Pengelompokan Form.csv.
import { RANAP_RM_FORMS } from "@/utils/ranapFormRegistry";
import { scrollTabIntoView } from "@/utils/scrollTabIntoView";
import { isRekamAsuhanHdIntensif, isSkriningBunuhDiriExcluded } from "@/utils/unit";

// Display order of tab categories (chips render in this order; empty categories are hidden).
const CATEGORY_ORDER: string[] = [
  "CPPT dan Asesmen",
  "Keperawatan dan Monitoring",
  "Perioperatif",
  "Kebidanan & BBL",
  "Clinical Pathway",
  "Intensif dan Kritis",
  "Resume dan MPP"
];

// elemId -> category, derived from the canonical list above.
const TAB_CATEGORY: Record<string, string> = RANAP_RM_FORMS.reduce(
  (acc, f) => {
    acc[f.elemId] = f.category;
    return acc;
  },
  {} as Record<string, string>
);

// elemId -> display order (index in the canonical list). Unmapped tabs sort last.
const TAB_ORDER: Record<string, number> = RANAP_RM_FORMS.reduce(
  (acc, f, i) => {
    acc[f.elemId] = i;
    return acc;
  },
  {} as Record<string, number>
);

@Component({
  components: {
    CpptRanapPage,
    AsesmenRanapMedisPage,
    AsesmenRanapKeperawatanPage,
    ResumeRanap,
    TandaVitalEws,
    CardPemeriksaanFisik,
    CardAsesmenRisikoJatuh,
    Partograf,
    AnamnesisPage,
    CatatanPemberianObatPage,
    RekonsiliasiObatPage,
    AsesmenNyeriPage,
    AsesmenRisikoJatuhPage,
    SkriningGiziLanjutPage,
    PemantauanTerapiGiziPage,
    SkriningPaliatifDewasaPage,
    SkriningPaliatifAnakPage,
    SkriningBunuhDiriPage,
    LaporanOperasiPage,
    CardAsesmenPraSedasi,
    CardAsesmenPraBedah,
    AskepRanapPage,
    RefAskepRanapPage,
    TransferInternalPage,
    TabBerkasRm,
    CardDischargePlanning,
    MppPage,
    KriteriaHcuPage,
    PemantauanPacuPage,
    CardPengkajianRestrain,
    CardCeklistProsedurInvasif,
    IdentitasBayiBaruLahirPage,
    EwssAnakPage,
    GrafikTtvDewasaPage,
    ChecklistPersiapanAnestesiPage,
    ChecklistKeselamatanOperasiPage,
    CatatanPraSedasiPage,
    CardCatatanPaskaSedasi,
    CatatanKebidananPage,
    AsesmenAwalKebidananPage,
    AsesmenAwalAnakPage,
    CardAsesmenBayiBaruLahir,
    CardCatatanEdukasi,
    CardAsesmenPerinatal,
    CatatanHarianBblPage,
    MonitoringHarianNicuPage,
    AsesmenPopulasiKhususPage,
    AsesmenGeriatriPage,
    PengkajianAkhirHayatPage,
    CodeBlueActivationPage,
    IcuHcuPage,
    BundlePpiPage,
    PenggunaanAlatReuseRanapTab,
    KepatuhanVisiteRanapTab,
    AsesmenKeperawatanIntensifPage,
    LembarObservasiKebidananPage,
    ObservasiKebidananBishopPage,
    CpBlankoPage,
    CardSebabKematian,
    AskeperPerioperatifPage,
    PemantauanAnestesiList,
    MonitoringIntraOpLokalPage,
    MonitoringTransfusiList,
    MonitoringGdsList,
    CardNihssAssessment,
    CardAssesmenKemoterapi,
    RekamAsuhanHemodialisisPage,
    MonitoringTrombolisisList
  }
})
export default class RekamMedisRanap extends Vue {
  @Prop() register!: number;
  @Prop() rm!: number;
  @Prop({ default: null }) isAsesmenMedisExist: boolean;
  @Prop({ default: null }) pasien!: any;
  @Prop({ default: null }) deepLink!: any;

  tab = null;
  listTransferItems: any[] = [];
  activeCategory = "CPPT dan Asesmen";
  pendingDeepLinkTab: string = null;

  mounted() {
    this.tab = "tab-cppt";
    this.loadDataMpp();
  }

  @Watch("tab")
  onTabChange() {
    this.$nextTick(() => scrollTabIntoView(this.$el));
  }

  // Tabs that pass their visibility gate, annotated with their category.
  get gatedTabs() {
    return this.tabs
      .filter((t) => t.visibility)
      .map((t) => ({ ...t, category: TAB_CATEGORY[t.elemId] || "Lainnya" }));
  }

  // Categories that currently have at least one visible tab, in display order.
  get visibleCategories(): string[] {
    const present = new Set(this.gatedTabs.map((t) => t.category));
    const ordered = CATEGORY_ORDER.filter((c) => present.has(c));
    present.forEach((c) => {
      if (!ordered.includes(c)) {
        ordered.push(c);
      }
    });
    return ordered;
  }

  // Tabs shown in the sidebar for the active category. Cross-category form
  // search lives in the global header search (PasienFlyingBar).
  get filteredTabs() {
    const base = this.gatedTabs.filter((t) => t.category === this.activeCategory);
    // Order forms to match the canonical grouping document (RANAP_RM_FORMS);
    // tab di luar RANAP_RM_FORMS ("Lainnya") sort to the end.
    const order = (id: string) =>
      TAB_ORDER[id] === undefined ? Number.MAX_SAFE_INTEGER : TAB_ORDER[id];
    return base.slice().sort((a, b) => order(a.elemId) - order(b.elemId));
  }

  // When the category changes, keep the active tab if it is still listed,
  // otherwise jump to the first tab of the newly selected category.
  @Watch("activeCategory")
  onActiveCategoryChange() {
    const stillVisible = this.filteredTabs.some((t) => t.elemId === this.tab);
    if (!stillVisible && this.filteredTabs.length) {
      this.tab = this.filteredTabs[0].elemId;
    }
  }

  // Universal-search deep link (PasienFlyingBar -> PemeriksaanRanap -> here):
  // when the payload targets this page, jump to the requested category + form.
  // Guarded by topTab so the shared prop is ignored by other sub-pages' copies.
  @Watch("deepLink", { immediate: true })
  onDeepLink(payload: any) {
    if (!payload || payload.topTab !== "tab-rekam-medis") {
      return;
    }
    if (payload.category) {
      this.activeCategory = payload.category;
    }
    this.pendingDeepLinkTab = payload.elemId || null;
    this.$nextTick(() => this.applyPendingDeepLink());
  }

  // Saat deep-link datang dari URL (tab browser baru), data pasien belum tentu
  // selesai dimuat sehingga form yang di-gate umur/unit belum tampil. Coba lagi
  // tiap daftar tab berubah, sampai form tujuan benar-benar terlihat.
  @Watch("filteredTabs")
  onFilteredTabsChange() {
    this.applyPendingDeepLink();
  }

  onTransferSent() {
    ptiStore.fetchByRegister(this.register ? Number(this.register) : null);
  }

  onNavigateTab(elemId: string) {
    if (!elemId) return;

    const kategori = TAB_CATEGORY[elemId];
    if (kategori) {
      this.activeCategory = kategori;
    }

    this.pendingDeepLinkTab = elemId;
    this.$nextTick(() => this.applyPendingDeepLink());
  }

  applyPendingDeepLink() {
    // Only select the form if it's actually visible for this patient
    // (age/unit-gated forms otherwise stay on the category's first tab).
    if (!this.pendingDeepLinkTab) {
      return;
    }
    if (this.filteredTabs.some((t) => t.elemId === this.pendingDeepLinkTab)) {
      this.tab = this.pendingDeepLinkTab;
      this.pendingDeepLinkTab = null;
    }
  }

  get tabs() {
    return [
      {
        name: "CPPT",
        href: "#tab-cppt",
        elemId: "tab-cppt",
        component: "CpptRanapPage",
        visibility: true,
        props: {
          isActive: this.tab === "tab-cppt",
          enableRencanaAsuhanV2: true
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Anamnesis",
        href: "#tab-anamnesis",
        elemId: "tab-anamnesis",
        component: "AnamnesisPage",
        visibility: true,
        props: {
          isActive: this.tab === "tab-anamnesis"
        },
        onClick: () => {
          return true;
        }
      },
      // {
      //   name: "Asesmen Nyeri",
      //   href: "#tab-asesmen-nyeri",
      //   elemId: "tab-asesmen-nyeri",
      //   component: "AsesmenNyeriPage",
      //   onClick: () => {
      //     return true;
      //   }
      // },
      {
        name: "Asesmen Risiko Jatuh",
        href: "#tab-asesmen-risjat",
        elemId: "tab-asesmen-risjat",
        component: "AsesmenRisikoJatuhPage",
        visibility: true,
        props: {
          isActive: this.tab === "tab-asesmen-risjat"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Bundle PPI",
        href: "#tab-bundle-ppi",
        elemId: "tab-bundle-ppi",
        component: "BundlePpiPage",
        visibility: true,
        props: {
          isActive: this.tab === "tab-bundle-ppi"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Penggunaan Alat Reuse",
        href: "#tab-penggunaan-alat-reuse",
        elemId: "tab-penggunaan-alat-reuse",
        component: "PenggunaanAlatReuseRanapTab",
        visibility: true,
        props: {
          isActive: this.tab === "tab-penggunaan-alat-reuse"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Asesmen Awal<br/> Ranap Medis",
        href: "#tab-asesmen-awal",
        elemId: "tab-asesmen-awal",
        component: "AsesmenRanapMedisPage",
        visibility: true,
        props: {
          isActive: this.tab === "tab-asesmen-awal"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Asesmen Awal Keperawatan<br/>Ranap Dewasa",
        href: "#tab-asesmen-awal-keperawatan",
        elemId: "tab-asesmen-awal-keperawatan",
        component: "AsesmenRanapKeperawatanPage",
        visibility: this.isDewasaPatient,
        props: {
          isActive: this.tab === "tab-asesmen-awal-keperawatan"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Skrining Gizi<br/>Lanjut",
        href: "#tab-skrining-gizi-lanjut",
        elemId: "tab-skrining-gizi-lanjut",
        component: "SkriningGiziLanjutPage",
        visibility: true,
        props: {
          isActive: this.tab === "tab-skrining-gizi-lanjut"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Pemantauan<br/>Terapi Gizi",
        href: "#tab-pemantauan-terapi-gizi",
        elemId: "tab-pemantauan-terapi-gizi",
        component: "PemantauanTerapiGiziPage",
        visibility: true,
        props: {
          isActive: this.tab === "tab-pemantauan-terapi-gizi"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Skrining Risiko<br/>Bunuh Diri",
        href: "#tab-skrining-bunuh-diri",
        elemId: "tab-skrining-bunuh-diri",
        component: "SkriningBunuhDiriPage",
        visibility: this.showSkriningBunuhDiri,
        props: {
          isActive: this.tab === "tab-skrining-bunuh-diri",
          encounterType: "ranap"
        },
        onClick: () => {
          return true;
        }
      },
      // Skrining paliatif (kategori "Keperawatan dan Monitoring") — dipisah per
      // populasi karena instrumen status fungsionalnya berbeda: ECOG untuk
      // dewasa, Skala Lansky untuk anak. Tab difilter umur pasien seperti
      // pasangan asesmen awal Dewasa/Anak.
      {
        name: "Skrining Paliatif<br/>Dewasa",
        href: "#tab-skrining-paliatif-dewasa",
        elemId: "tab-skrining-paliatif-dewasa",
        component: "SkriningPaliatifDewasaPage",
        visibility: this.isDewasaPatient,
        props: {
          isActive: this.tab === "tab-skrining-paliatif-dewasa",
          encounterType: "ranap"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Skrining Paliatif<br/>Anak",
        href: "#tab-skrining-paliatif-anak",
        elemId: "tab-skrining-paliatif-anak",
        component: "SkriningPaliatifAnakPage",
        visibility: this.isAnakPatient,
        props: {
          isActive: this.tab === "tab-skrining-paliatif-anak",
          encounterType: "ranap"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Catatan<br/>Edukasi",
        href: "#tab-catatan-edukasi",
        elemId: "tab-catatan-edukasi",
        component: "CardCatatanEdukasi",
        visibility: true,
        props: {
          isActive: this.tab === "tab-catatan-edukasi"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Asesmen Bayi<br/>Baru Lahir",
        href: "#tab-asesmen-bbl",
        elemId: "tab-asesmen-bbl",
        component: "CardAsesmenBayiBaruLahir",
        visibility: false,
        props: {
          isActive: this.tab === "tab-asesmen-bbl"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Catatan Harian<br/>BBL",
        href: "#tab-catatan-harian-bbl",
        elemId: "tab-catatan-harian-bbl",
        component: "CatatanHarianBblPage",
        visibility: true,
        props: {
          isActive: this.tab === "tab-catatan-harian-bbl"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Monitor Harian<br/>NICU",
        href: "#tab-monitoring-harian-nicu",
        elemId: "tab-monitoring-harian-nicu",
        component: "MonitoringHarianNicuPage",
        visibility: true,
        props: {
          isActive: this.tab === "tab-monitoring-harian-nicu"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Partograf",
        href: "#tab-partograf",
        elemId: "tab-partograf",
        component: "Partograf",
        visibility: true,
        props: {
          register: this.register,
          rm: this.rm,
          isActive: this.tab === "tab-partograf"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Asesmen<br/>Perinatal",
        href: "#tab-asesmen-perinatal",
        elemId: "tab-asesmen-perinatal",
        component: "CardAsesmenPerinatal",
        visibility: true,
        props: {
          isActive: this.tab === "tab-asesmen-perinatal"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Asesmen Awal Ranap<br/>Kebidanan",
        href: "#tab-asesmen-kebidanan",
        elemId: "tab-asesmen-kebidanan",
        component: "AsesmenAwalKebidananPage",
        visibility: true,
        props: {
          isActive: this.tab === "tab-asesmen-kebidanan"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Asesmen Awal<br/>Keperawatan Anak",
        href: "#tab-asesmen-anak",
        elemId: "tab-asesmen-anak",
        component: "AsesmenAwalAnakPage",
        visibility: this.isAnakPatient,
        props: {
          isActive: this.tab === "tab-asesmen-anak",
          pasienData: storePasien.identitasPasien
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Resume Ranap/ <br/>Ringkasan Pulang",
        href: "#tab-resume-ranap",
        elemId: "tab-resume-ranap",
        component: "ResumeRanap",
        visibility: true,
        props: {
          isActive: this.tab === "tab-resume-ranap"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Discharge Planning<br/>(Perencanaan Pulang)",
        href: "#tab-discharge-planning",
        elemId: "tab-discharge-planning",
        component: "CardDischargePlanning",
        visibility: true,
        props: {},
        onClick: () => {
          return true;
        }
      },
      {
        name: "Monitor TTV",
        href: "#tab-tanda-vital",
        elemId: "tab-tanda-vital",
        component: "TandaVitalEws",
        visibility: true,
        props: {
          isActive: this.tab === "tab-tanda-vital"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Grafik TTV<br/>Dewasa",
        href: "#tab-grafik-ttv",
        elemId: "tab-grafik-ttv",
        component: "GrafikTtvDewasaPage",
        visibility: true,
        props: {
          isActive: this.tab === "tab-grafik-ttv"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "EWSS<br/>Anak",
        href: "#tab-ewss-anak",
        elemId: "tab-ewss-anak",
        component: "EwssAnakPage",
        // sementara disembunyikan — belum dipakai user (aktifkan lagi: this.isAnakPatient)
        visibility: false,
        props: {
          isActive: this.tab === "tab-ewss-anak"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Ceklist<br/>Prosedur Invasif",
        href: "#tab-ceklist-invasif",
        elemId: "tab-ceklist-invasif",
        component: "CardCeklistProsedurInvasif",
        visibility: true,
        props: {
          isActive: this.tab === "tab-ceklist-invasif"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Asesmen<br/>Pra Anestesi/Sedasi",
        href: "#tab-asesmen-pra-sedasi",
        elemId: "tab-asesmen-pra-sedasi",
        component: "CardAsesmenPraSedasi",
        visibility: true,
        props: {
          isActive: this.tab === "tab-asesmen-pra-sedasi"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Asesmen<br/>Pra Bedah",
        href: "#tab-asesmen-pra-bedah",
        elemId: "tab-asesmen-pra-bedah",
        component: "CardAsesmenPraBedah",
        visibility: true,
        props: {
          isActive: this.tab === "tab-asesmen-pra-bedah"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Laporan Operasi",
        href: "#tab-laporan-operasi",
        elemId: "tab-laporan-operasi",
        component: "LaporanOperasiPage",
        visibility: true,
        props: {
          isActive: this.tab === "tab-laporan-operasi"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Checklist<br>Anestesi",
        href: "#tab-checklist-anestesi",
        elemId: "tab-checklist-anestesi",
        component: "ChecklistPersiapanAnestesiPage",
        visibility: true,
        props: {
          isActive: this.tab === "tab-checklist-anestesi"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Checklist<br/>Keselamatan OK",
        href: "#tab-checklist-ok",
        elemId: "tab-checklist-ok",
        component: "ChecklistKeselamatanOperasiPage",
        visibility: true,
        props: {
          isActive: this.tab === "tab-checklist-ok"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Catatan Pra<br/>Anestesi/Sedasi",
        href: "#tab-pra-sedasi",
        elemId: "tab-pra-sedasi",
        component: "CatatanPraSedasiPage",
        visibility: true,
        props: {
          isActive: this.tab === "tab-pra-sedasi"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Catatan Paska<br/>Anestesi",
        href: "#tab-catatan-paska-sedasi",
        elemId: "tab-catatan-paska-sedasi",
        component: "CardCatatanPaskaSedasi",
        visibility: true,
        props: {
          isActive: this.tab === "tab-catatan-paska-sedasi"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Catatan Pemberian Obat",
        href: "#tab-catatan-pemberian-obat",
        elemId: "tab-catatan-pemberian-obat",
        component: "CatatanPemberianObatPage",
        visibility: true,
        props: {
          isActive: this.tab === "tab-catatan-pemberian-obat"
        },
        onClick: () => {
          // return true;
          this.getByRegister();
        }
      },
      {
        name: "Rekonsiliasi<br/>Obat",
        href: "#tab-rekonsiliasi-obat",
        elemId: "tab-rekonsiliasi-obat",
        component: "RekonsiliasiObatPage",
        visibility: true,
        props: {
          isActive: this.tab === "tab-rekonsiliasi-obat"
        },
        onClick: () => {
          // return true;
          this.getByRegister();
        }
      },
      {
        name: "Asuhan Keperawatan",
        href: "#tab-askep",
        elemId: "tab-askep",
        component: "AskepRanapPage",
        visibility: true,
        props: {
          isActive: this.tab === "tab-askep"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Pengkajian Restrain",
        href: "#tab-pengkajian-restrain",
        elemId: "tab-pengkajian-restrain",
        component: "CardPengkajianRestrain",
        visibility: true,
        props: {
          isActive: this.tab === "tab-pengkajian-restrain"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Identitas Bayi<br/> Baru Lahir",
        href: "#tab-identitas-bayi",
        elemId: "tab-identitas-bayi",
        component: "IdentitasBayiBaruLahirPage",
        visibility: true,
        props: {
          isActive: this.tab === "tab-identitas-bayi"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Implementasi",
        href: "#tab-catatan-kebidanan",
        elemId: "tab-catatan-kebidanan",
        component: "CatatanKebidananPage",
        visibility: true,
        props: {
          isActive: this.tab === "tab-catatan-kebidanan"
        },
        onClick: () => {
          return true;
        }
      },
      {
        // Lembar Observasi Persalinan (RM.RI.19m.01) — hanya tabel observasi time-series
        // dengan Bishop Score otomatis per-baris (SOAP/asesmen sesi telah dilepas).
        name: "Observasi Kebidanan",
        href: "#tab-observasi-kebidanan",
        elemId: "tab-observasi-kebidanan",
        component: "LembarObservasiKebidananPage",
        visibility: true,
        props: {
          isActive: this.tab === "tab-observasi-kebidanan",
          registerId: this.register,
          pasienRm: this.rm != null ? String(this.rm) : "",
          unitId: this.unitRawatAktif
        },
        onClick: () => {
          return true;
        }
      },
      {
        // IMP-083: disembunyikan — digabung ke tab "Observasi Kebidanan + Bishop Score" (LembarObservasiKebidananPage).
        // Backend/data observasi_kebidanan_bishop dipertahankan (reversible).
        name: "Observasi Kebidanan<br/>+ Bishop Score (lama)",
        href: "#tab-observasi-kebidanan-bishop",
        elemId: "tab-observasi-kebidanan-bishop",
        component: "ObservasiKebidananBishopPage",
        visibility: false,
        props: {
          isActive: this.tab === "tab-observasi-kebidanan-bishop",
          registerId: this.register,
          pasienRm: this.rm != null ? String(this.rm) : "",
          unitId: this.unitRawatAktif
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Clinical Pathway",
        href: "#tab-cp",
        elemId: "tab-cp",
        component: "CpBlankoPage",
        visibility: true,
        props: {
          isActive: this.tab === "tab-cp",
          registerId: this.register,
          pasienRm: this.rm != null ? String(this.rm) : "",
          unitId: this.unitRawatAktif
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Asesmen Populasi<br/>Khusus",
        href: "#tab-asesmen-populasi-khusus",
        elemId: "tab-asesmen-populasi-khusus",
        component: "AsesmenPopulasiKhususPage",
        visibility: true,
        props: {
          isActive: this.tab === "tab-asesmen-populasi-khusus"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Asesmen<br/>Geriatri",
        href: "#tab-asesmen-geriatri",
        elemId: "tab-asesmen-geriatri",
        component: "AsesmenGeriatriPage",
        visibility: this.isGeriatriPatient,
        props: {
          isActive: this.tab === "tab-asesmen-geriatri"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Asesmen Pasien<br/>Kemoterapi",
        href: "#tab-asesmen-kemo",
        elemId: "tab-asesmen-kemo",
        component: "CardAssesmenKemoterapi",
        visibility: true,
        props: {},
        onClick: () => {
          return true;
        }
      },
      {
        name: "Pengkajian<br/>Akhir Hayat",
        href: "#tab-pengkajian-akhir-hayat",
        elemId: "tab-pengkajian-akhir-hayat",
        component: "PengkajianAkhirHayatPage",
        visibility: true,
        props: {
          isActive: this.tab === "tab-pengkajian-akhir-hayat"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Pencatatan<br/>Code Blue",
        href: "#tab-code-blue",
        elemId: "tab-code-blue",
        component: "CodeBlueActivationPage",
        visibility: true,
        props: {
          isActive: this.tab === "tab-code-blue"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "ICU/HCU/ICCU",
        href: "#tab-icu-hcu",
        elemId: "tab-icu-hcu",
        component: "IcuHcuPage",
        visibility: true,
        props: {
          isActive: this.tab === "tab-icu-hcu"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Monitoring<br/>Trombolisis",
        href: "#tab-monitoring-trombolisis",
        elemId: "tab-monitoring-trombolisis",
        component: "MonitoringTrombolisisList",
        visibility: true,
        props: {},
        onClick: () => {
          return true;
        }
      },
      {
        name: "Rekam Asuhan<br/>Hemodialisis",
        href: "#tab-rekam-asuhan-hd",
        elemId: "tab-rekam-asuhan-hd",
        component: "RekamAsuhanHemodialisisPage",
        visibility: this.showRekamAsuhanHd,
        props: {
          isActive: this.tab === "tab-rekam-asuhan-hd",
          encounterType: "ranap"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Asesmen Awal Keperawatan<br/>Intensif",
        href: "#tab-asesmen-kep-intensif",
        elemId: "tab-asesmen-kep-intensif",
        component: "AsesmenKeperawatanIntensifPage",
        visibility: true,
        props: {
          isActive: this.tab === "tab-asesmen-kep-intensif"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "MPP",
        href: "#tab-mpp",
        elemId: "tab-mpp",
        component: "MppPage",
        visibility: true,
        props: {
          isActive: this.tab === "tab-mpp"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "PACU / RR",
        href: "#tab-pacu-rr",
        elemId: "tab-pacu-rr",
        component: "PemantauanPacuPage",
        visibility: true,
        props: {
          isActive: this.tab === "tab-pacu-rr"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Kepatuhan<br/>Visite DPJP",
        href: "#tab-kepatuhan-visite",
        elemId: "tab-kepatuhan-visite",
        component: "KepatuhanVisiteRanapTab",
        visibility: true,
        props: {
          isActive: this.tab === "tab-kepatuhan-visite"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Sebab<br/>Kematian",
        href: "#tab-sebab-kematian",
        elemId: "tab-sebab-kematian",
        component: "CardSebabKematian",
        visibility: true,
        props: {
          isActive: this.tab === "tab-sebab-kematian"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Askep<br/>Perioperatif",
        href: "#tab-askeper-perioperatif",
        elemId: "tab-askeper-perioperatif",
        component: "AskeperPerioperatifPage",
        visibility: true,
        props: {},
        onClick: () => {
          return true;
        }
      },
      {
        name: "Pemantauan<br/>Anestesi/Sedasi",
        href: "#tab-pemantauan-anestesi",
        elemId: "tab-pemantauan-anestesi",
        component: "PemantauanAnestesiList",
        visibility: true,
        props: {},
        onClick: () => {
          return true;
        }
      },
      {
        name: "Monitoring<br/>Intra-Op Lokal",
        href: "#tab-monitoring-intra-op-lokal",
        elemId: "tab-monitoring-intra-op-lokal",
        component: "MonitoringIntraOpLokalPage",
        visibility: true,
        props: {},
        onClick: () => {
          return true;
        }
      },
      {
        name: "Monitoring<br/>Transfusi",
        href: "#tab-monitoring-transfusi",
        elemId: "tab-monitoring-transfusi",
        component: "MonitoringTransfusiList",
        visibility: true,
        props: {},
        onClick: () => {
          return true;
        }
      },
      {
        name: "Monitoring<br/>GDS",
        href: "#tab-monitoring-gds",
        elemId: "tab-monitoring-gds",
        component: "MonitoringGdsList",
        visibility: true,
        props: {},
        onClick: () => {
          return true;
        }
      },
      {
        name: "Penilaian<br/>NIHSS",
        href: "#tab-nihss",
        elemId: "tab-nihss",
        component: "CardNihssAssessment",
        visibility: true,
        props: {
          isActive: this.tab === "tab-nihss"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Transfer Internal",
        href: "#tab-transfer-internal",
        elemId: "tab-transfer-internal",
        component: "TransferInternalPage",
        visibility: true,
        props: {
          isActive: this.tab === "tab-transfer-internal",
          reload: true
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Berkas Manual RM",
        href: "#tab-berkas-rm",
        elemId: "tab-berkas-rm",
        component: "TabBerkasRm",
        visibility: true,
        props: {
          isActive: this.tab === "tab-berkas-rm"
        },
        onClick: () => {
          return true;
        }
      }

      // {
      //   name: "Ref Askep",
      //   href: "#tab-refaskep",
      //   elemId: "tab-refaskep",
      //   component: "RefAskepRanapPage",
      //   visibility: [404, 310, 383, 225].includes(this.stateuser.id),
      //   props: {
      //     isActive: this.tab === "tab-refaskep"
      //   },
      //   onClick: () => {
      //     return true;
      //   }
      // }
      // {
      //   name: "Partograf",
      //   href: "#tab-partograf",
      //   elemId: "tab-partograf",
      //   component: "Partograf"
      // }
    ];
  }

  // Unit Kebidanan/Perinatal: UTARI (63) = Ruang Bersalin, KUNTHI (56) = Kebidanan/Nifas, ABIMANYU (64) = Perinatologi
  readonly UNIT_KEBIDANAN_PERINATAL = ["56", "63", "64"];
  // Unit Intensif: 50 Wisnu (ICU Covid), 5A Dewaruci (HCU), 5B Dewaruci (PICU), 5C Wisnu (ICU Lt 3), 5D Ismaya (ICCU), 5F Dewaruci (ICU)
  readonly UNIT_INTENSIF = ["50", "5A", "5B", "5C", "5D", "5F"];

  get unitRawatAktif(): string {
    const register = RegisterKunjungan.register;
    if (!register) return "";
    const jurnal = register.jurnal_ranap;
    if (jurnal?.length) {
      const last = jurnal[jurnal.length - 1];
      if (last?.unit?.id) return last.unit.id;
    }
    // Fallback ke unit aktif di register (cm_reg__.unit) saat belum ada mutasi ranap
    return register.unit || "";
  }

  get isUnitKebidanPerinatal(): boolean {
    return this.UNIT_KEBIDANAN_PERINATAL.includes(this.unitRawatAktif);
  }

  get isUnitIntensif(): boolean {
    return this.UNIT_INTENSIF.includes(this.unitRawatAktif);
  }

  get showRekamAsuhanHd(): boolean {
    return [this.stateuser?.unit_id, this.stateuser?.unit_group_id].some(kode =>
      isRekamAsuhanHdIntensif(kode)
    );
  }

  get showSkriningBunuhDiri(): boolean {
    return (
      !!this.unitRawatAktif &&
      !isSkriningBunuhDiriExcluded(
        this.unitRawatAktif,
        userModule.segmentUnitId,
        userModule.loginUnitId
      )
    );
  }

  // tgl_lahir format: "DD-MM-YYYY" → Date | null
  parseTglLahir(): Date | null {
    const pasien = storePasien.identitasPasien;
    if (!pasien?.tgl_lahir) return null;
    const parts = pasien.tgl_lahir.split("-");
    const tglLahir = parts.length === 3
      ? new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]))
      : new Date(pasien.tgl_lahir);
    return isNaN(tglLahir.getTime()) ? null : tglLahir;
  }

  // Usia dalam hari (untuk membedakan BBL ≤30 hari), null bila tgl lahir tidak valid.
  get patientAgeDays(): number | null {
    const tglLahir = this.parseTglLahir();
    if (!tglLahir) return null;
    const ms = new Date().getTime() - tglLahir.getTime();
    return Math.floor(ms / (1000 * 60 * 60 * 24));
  }

  get patientAgeYears(): number | null {
    const tglLahir = this.parseTglLahir();
    if (!tglLahir) return null;
    const now = new Date();
    let usia = now.getFullYear() - tglLahir.getFullYear();
    const m = now.getMonth() - tglLahir.getMonth();
    if (m < 0 || (m === 0 && now.getDate() < tglLahir.getDate())) {
      usia--;
    }
    return usia;
  }

  // RAN-042 — pemisahan umur asesmen: BBL 0–30 hari, Anak 30 hari–18 th, Dewasa 18 th+.
  get isBblPatient(): boolean {
    const d = this.patientAgeDays;
    return d !== null && d <= 30;
  }

  get isAnakPatient(): boolean {
    const d = this.patientAgeDays;
    const y = this.patientAgeYears;
    return d !== null && y !== null && d > 30 && y < 18;
  }

  get isDewasaPatient(): boolean {
    const y = this.patientAgeYears;
    // Default ke Dewasa bila usia tidak diketahui (fallback aman — mayoritas pasien dewasa).
    return y === null || y >= 18;
  }

  get isGeriatriPatient(): boolean {
    return isUsiaGeriatri(storePasien.identitasPasien?.tgl_lahir);
  }

  get stateuser() {
    return userModule.user;
  }

  async loadDataMpp() {
    try {
      await MppModule.fetchAllMpp(this.register);
    } catch (error) {
      console.error("Gagal memuat data MPP:", error);
    }
  }

  // badge ada asuhan mpp
  get isAdaAsuhanMpp(): boolean {
    const dataTerbaru = MppModule.getSkrining[0];
    if (!dataTerbaru || !Array.isArray(dataTerbaru.content)) return false;

    // Ada asuhan jika ada data di content DAN ID-nya bukan "42"
    return dataTerbaru.content.some((c: any) => String(c.id) !== "42");
  }

  @Watch("register")
  onRegisterChanged() {
    this.loadDataMpp();
  }

  @Watch("isAsesmenMedisExist")
  changedIsAsesmenMedisExist(val) {
    if (!val) {
      this.activeCategory = "CPPT dan Asesmen";
      this.tab = "tab-asesmen-awal";
    }
  }

  async getByRegister() {
    await CatatanPemberianObatStore.getByRegister(this.register).then(() => {});
  }
}
